import { render } from "./NotificationForm.vue?vue&type=template&id=12543ba2&scoped=true"
import script from "./NotificationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationForm.vue?vue&type=script&setup=true&lang=js"

import "./NotificationForm.vue?vue&type=style&index=0&id=12543ba2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12543ba2"],['__file',"resources/js/modules/notification/components/form/NotificationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12543ba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12543ba2', __exports__)) {
    api.reload('12543ba2', __exports__)
  }
  
  module.hot.accept("./NotificationForm.vue?vue&type=template&id=12543ba2&scoped=true", () => {
    api.rerender('12543ba2', render)
  })

}


export default __exports__